import { render } from "./CartTableRow.vue?vue&type=template&id=e0736756&ts=true"
import script from "./CartTableRow.vue?vue&type=script&lang=ts"
export * from "./CartTableRow.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/momo-store-main/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__